import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { paymentProviderTypes } from '../types';

import { axios } from '@/libraries/axios';
import { MutationConfig, queryClient } from '@/libraries/react-query';
import { Departments } from '@/types';
import { toasts } from '@/utils/toasts';

export const editPaymentProvider = (
  data: paymentProviderTypes.EditPaymentProviderData
): Promise<{ paymentProvider: paymentProviderTypes.PaymentProvider }> => {
  const { _id, ...dataWithoutId } = data;
  return axios.patch(`/payment-providers/${_id}`, { data: dataWithoutId });
};

type EditPaymentProviderOptions = {
  department: Departments;
  onSuccess: () => void;
  config?: MutationConfig<typeof editPaymentProvider>;
};

export function useEditPaymentProvider({
  config = {},
  department,
  onSuccess,
}: EditPaymentProviderOptions) {
  return useMutation({
    ...config,
    onSuccess: () => {
      queryClient.invalidateQueries(['payment-providers', department]);
      toasts.loadingToast.success('edit-payment-provider', 'Payment provider updated successfully');
      onSuccess();
    },
    onError: (error: AxiosError<{ error: string }>, ...args) => {
      const serverMessage = error.response?.data?.error;
      toasts.loadingToast.error('edit-payment-provider', serverMessage);
      config.onError?.(error, ...args);
    },
    onMutate: (...args) => {
      toasts.loadingToast.loading('edit-payment-provider', 'Updating payment provider...');
      config.onMutate?.(...args);
    },
    mutationFn: editPaymentProvider,
  });
}
